import { Subscription } from "rxjs"
import { Component, OnInit } from '@angular/core';
import { AuthService } from './auth/auth.service';
import { NbSearchService, NbSidebarService, NbMenuItem, NbMenuService } from '@nebular/theme';
import { SocketioService } from './socketio.service';
import { SwUpdate } from '@angular/service-worker';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  userIsAuthenticated = false;
  private authListenerSubs: Subscription;

  userEmailId = localStorage.getItem("emailId");

  menuItems: NbMenuItem[] = [
    {
      title: 'Dashboard',
      icon: 'home-outline',
      link: '/home',
      home: true
    },
    {
      title: 'eGlu Users',
      icon: 'people-outline',
      link: '/users',
    },
    {
      title: 'eGlu Map',
      icon: 'map-outline',
      link: '/maps',
    },
    {
      title: 'Utils',
      icon: 'options-2-outline',
      link: '/utils',
    },
    {
      title: 'Activity Log',
      icon: 'file-text-outline',
      link: '/activitylogs',
    },
    // {
    //   title: 'eGlu Ratings',
    //   icon: 'star-outline',
    //   link: '/ratings',
    // },
    // {
    //   title: 'Devices',
    //   icon: 'grid-outline',
    //   link: '/devices',
    // },
    // {
    //   title: 'INTERNAL',
    //   group: true,
    // },
    // {
    //   title: 'Transfers',
    //   icon: 'arrow-forward-outline',
    //   link: '/transfers',
    // },
    // {
    //   title: 'Replacements',
    //   icon: 'swap-outline',
    //   link: '/replacements',
    // },
    {
      title: 'Minimize',
      icon: 'arrow-ios-back-outline',
    },
  ];

  items = [
    // {
    //   title: 'Profile',
    //   icon: 'person-outline',
    // },
    {
      title: 'Logout',
      icon: 'unlock-outline',
    },
  ];

  value = "";


  constructor(private socketService: SocketioService, private nbMenuService: NbMenuService, private authService: AuthService, private searchService: NbSearchService, private sidebarService: NbSidebarService) {

  }

  toggleSidebar() {
    this.sidebarService.toggle();
  }

  onLogout() {
    this.authService.logout();
  }



  ngOnInit() {
    this.authService.autoAuthUser();

    this.userIsAuthenticated = this.authService.getIsAuth();
    this.authListenerSubs = this.authService.getAuthStatusListener().subscribe(isAuthenticated => {
      this.userIsAuthenticated = isAuthenticated.success;
      this.userEmailId = this.authService.getEmailId();
    });

    this.nbMenuService.onItemClick().subscribe((event) => {
      if (event.item.title === 'Logout') {
        console.log('logout clicked');
        this.onLogout();
      } else if (event.item.title === 'Minimize') {
        this.sidebarService.toggle(true, 'right');
      }
    });

    // if(this.userIsAuthenticated)
    //   this.socketService.setupSocketConnection();

    // this.swUpdate.available.subscribe(event => {
    //   console.log('A newer version is now available. Refresh the page now to update the cache');
    //   this.promptUser();
    // });

    //this.swUpdate.checkForUpdate()

    if ('caches' in window) {
      caches.keys()
        .then(function(keyList) {
            return Promise.all(keyList.map(function(key) {
                return caches.delete(key);
            }));
        })
    }
    
    if(window.navigator && navigator.serviceWorker) {
      navigator.serviceWorker.getRegistrations()
      .then(function(registrations) {
        for(let registration of registrations) {
          registration.unregister();
        }
      });
    }
  }
  promptUser() {
    console.log('updating to new version');
    //this.swUpdate.activateUpdate().then(() => document.location.reload());
  }

  ngOnDestroy() {
    this.authListenerSubs.unsubscribe();
  }
}
